import { DirectoryGroup } from "../../directory/types";

type ServerAccessDenied = {
  resolve_via?: { group_join?: DirectoryGroup[] };
};

// The server rendered errors/unauthorized for this path (data element in
// errors/unauthorized.html.haml). Returns its JSON payload, or null if the
// current page was not rejected by the server.
export default function serverAccessDenied(
  pathname: string,
): ServerAccessDenied | null {
  const element = document.getElementById("server-access-denied");
  if (
    !element ||
    normalizePath(element.dataset.path || "") !== normalizePath(pathname)
  )
    return null;

  try {
    return JSON.parse(element.dataset.payload || "{}");
  } catch {
    return {};
  }
}

// Rails normalizes request.path (no trailing slash, uppercase %xx escapes),
// location.pathname does not
export function normalizePath(path: string): string {
  return path
    .replace(/\/{2,}/g, "/")
    .replace(/(.)\/$/, "$1")
    .split("/")
    .map((segment) => {
      try {
        return decodeURIComponent(segment);
      } catch {
        return segment;
      }
    })
    .join("/");
}
